import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { AdminUserResponse } from "@authory-packages/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "#2e77ff",
  },
}));

export const SessionLoadingIndicator: React.FC<{
  session: AdminUserResponse | null;
}> = ({ session, children }) => {
  const classes = useStyles();

  if (session === null) {
    return (
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress color="inherit" />
        <Typography component="p" variant="subtitle2">
          Logging you in...
        </Typography>
      </Backdrop>
    );
  } else {
    return <>{children}</>;
  }
};
